module.exports = __webpack_public_path__ + "img/allottee1_7-8-2021.d6d86ed8.jpg";